/**
 * @format
 */
import { Directive, ElementRef, HostListener, Input, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { CleanVariableOnPasteService } from "./clean-variable-on-paste.service";

@Directive({
   selector: "[cleanVariableContentAfterPaste]",
})
export class CleanVariableAfterPasteDirective implements OnDestroy {
   private _timeout: NodeJS.Timeout;

   constructor(
      private elementRef: ElementRef,
      private store: Store<any>,
      private cleanVariableOnPasteService: CleanVariableOnPasteService
   ) {}

   @Input() modelVariableName: string;

   @HostListener("paste", ["$event"]) onPaste(event: ClipboardEvent): void {
      try {
         const clipboardData = event.clipboardData;
         const pastedPlainText = clipboardData.getData("text/plain");

         this.setCleanContentAfter(0, pastedPlainText);
         event.stopPropagation();
         event.preventDefault();
      } catch (error) {
         console.error("Handled error on CleanAfterPaste directive:", error);
      }
   }

   ngOnDestroy() {
      clearTimeout(this._timeout);
   }

   private setCleanContentAfter(milliseconds: number, plainText: string): void {
      const cleanContent = () => {
         const cleanText = this.cleanVariableOnPasteService.removeSpaceOrNewline(plainText);
         const selection = window.getSelection();
         const htmlElement = this.elementRef.nativeElement.firstElementChild;

         this.cleanVariableOnPasteService.setClenTextInRange(selection, cleanText);
         this.cleanVariableOnPasteService.updateTemplateModelVariable(htmlElement.innerHTML, this.modelVariableName);
      };

      if (Boolean(this._timeout)) {
         clearTimeout(this._timeout);
      }

      this._timeout = setTimeout(cleanContent, milliseconds);
   }
}
